import type TranslatedRouteHandle from "./TranslatedRouteHandle";
import type { TranslationHandleOptions } from "./TranslationHandleOptions";

export default function translationHandle(
  options: TranslationHandleOptions,
): TranslatedRouteHandle {
  return {
    i18n: Object.entries(options.ns)
      .filter(([_, enabled]) => enabled)
      .map(([ns]) => ns),
  };
}
